import React from "react";
import styled from "styled-components";
import Select from "components/common/Select";
import { Button, ListGroup, ListGroupItem } from "components/bootstrap";
const StyledListGroupItem = styled(ListGroupItem)`
  display: flex;
  justify-content: space-between;
`;
class SelectableList extends React.Component {
  constructor() {
    super(...arguments);
    this._getOptionId = (option) => typeof option === "string" ? option : option[this.props.idKey];
    this._getOptionDisplayValue = (option) => typeof option === "string" ? option : option[this.props.displayKey];
    this._onAddOption = (option) => {
      if (option === "") {
        return;
      }
      const newSelectedOptions = this.props.selectedOptions.slice();
      if (this.props.selectedOptionsType === "string") {
        newSelectedOptions.push(option);
      } else {
        newSelectedOptions.push(this.props.options.filter((o) => this._getOptionId(o) === option)[0]);
      }
      if (typeof this.props.onChange === "function") {
        this.props.onChange(newSelectedOptions);
      }
    };
    this._onRemoveOption = (optionIndex) => () => {
      const newSelectedOptions = this.props.selectedOptions.filter((_, idx) => idx !== optionIndex);
      if (typeof this.props.onChange === "function") {
        this.props.onChange(newSelectedOptions);
      }
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedOptions !== nextProps.selectedOptions) {
      this.select.clearValue();
    }
  }
  render() {
    const formattedOptions = this.props.selectedOptions.map((option, idx) => /* @__PURE__ */ React.createElement(StyledListGroupItem, { key: `${this._getOptionId(option)}-${idx}` }, /* @__PURE__ */ React.createElement("div", null, this._getOptionDisplayValue(option)), /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: this._onRemoveOption(idx) }, "Remove")));
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      Select,
      {
        ref: (select) => {
          this.select = select;
        },
        autoFocus: this.props.autoFocus,
        options: this.props.options,
        onChange: this._onAddOption,
        clearable: false
      }
    ), formattedOptions.length > 0 && /* @__PURE__ */ React.createElement(ListGroup, { style: { marginTop: 10 } }, formattedOptions));
  }
}
SelectableList.defaultProps = {
  autoFocus: void 0,
  displayKey: "label",
  idKey: "value",
  onChange: void 0,
  options: void 0,
  selectedOptions: void 0,
  selectedOptionsType: "string"
};
export default SelectableList;
